
  import { Component, Vue } from 'vue-property-decorator';
  import accountService from '@/services/account.service';
  import errorsService from '@/services/errors.service';
  import routeService from '@/services/route.service';

  import { IRequestResultModel } from '@/models/request.model';

  @Component({})
  export default class RegisterValidate extends Vue {
    created() {
      if (this.$route.query["verificationCode"] != null) {
        this.$store.dispatch("updateIsLoading", true);
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "register/verify";

        accountService.post<object, IRequestResultModel>(this, url, { VerificationCode: this.$route.query["verificationCode"] })
          .then(() => {
            this.$store.dispatch("updateIsLoading", false);
            routeService.redirectToLogin(this, this.$route.query.redirectUrl as string);
          })
          .catch(error => {
            this.$store.dispatch("updateIsLoading", false);
            errorsService.handleErrors(this, error);
          });
      }
      else {
        this.$router.push({ name: 'BadRequestError', query: { 'message': "This request should have a verification code." } });
      }
    }
  }
